import { Tooltip } from 'antd';
import { setCurrentWorkspace } from 'app-redux/actions/licensingAccounts.actions';
import { setCurrentOrg } from 'app-redux/actions/org.actions';
import { getStoreAppsPerWorkspace } from 'app-redux/actions/storeApps.actions';
import { createNewWorkspace, deleteWorkspace, editWorkspace, getWorkspaceById } from 'app-redux/actions/workspace.actions';
import { getCurrentUser } from 'app-redux/selectors/accounts.selector';
import { getDefaultWorkspace } from 'app-redux/selectors/licensingAccounts.selector';
import { getCurrentOrg } from 'app-redux/selectors/orgs.selector';
import HomeIcon from 'assets/icons/home.svg';
import MemberIcon from 'assets/icons/member.svg';
import PersonIcon from 'assets/icons/person.svg';
import PlanIcon from 'assets/icons/plan.svg';
import { LearnMore } from 'components/LearnMore';
import { WorkspaceCreateEditModal } from 'components/Modals/WorkspaceCreateEditModal/WorkspaceCreateEditModal';
import { WorkspaceSelection } from 'components/Workspace/WorkspaceSelection/WorkSpaceMenu/WorkspaceSelection';
import { history, RoutePaths } from 'core/history';
import { UUID } from 'core/utils/BasicModels';
import { WorkspaceEdit } from 'core/workspace/models';
import { get } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { EventBus } from 'services/EventBus';
import { getOrgsAndProperties } from 'services/MemberService';
import { getOrgPropertyRBACActions, verifyRBACPermission } from 'services/rbac';
import { RBAC_ACTIONS } from 'services/rbacActions';
import { Sidebar } from 'syngenta-digital-cropwise-react-ui-kit';
import { checkOrgOwnership, isPermissionAccess, translationWrapper, checkUserPermissionWithOrgsOwnerShip } from 'utils/common-methods';
import './SideBar.less';

const WsSidebar = (props: any) => {

    const { t } = translationWrapper(useTranslation());
    const { handleCancel=()=>false, currentWorkspaceId, deleteWorkspace: deleteWorkspaceAction, editWorkspace: editWorkspaceAction, createWorkspace: createWorkspaceAction } = props;
    const [selectedMenu, setSelectedMenu] = useState<any>('1');

    const [isEditWorkSpace, setIsEditWorkSpace] = useState<any>('');
    const [deleteModalVisible, setDeleteModalVisible] = useState<any>(false);
    const [isPermissionToMember, setIsPermissionToMember] = useState<any>(false);
    const { currentOrg, currentUser } = props;
    const currentOrgId = get(currentOrg, 'id', undefined);

    const getSelectedWorkspaceAndOrgId = () => {
      const searchParams = new URLSearchParams()
      const wsId = getDefaultWorkspace();

      if(wsId) searchParams.append('workspace', wsId)
      if(currentOrgId) searchParams.append('organization', currentOrgId)

      const search = searchParams.toString()

      return search ? { search } : {}
    };

    useEffect(() => {
        EventBus.$on('workspaceEditEvent', (ws: any) => {
            console.log(ws)
            setIsEditWorkSpace(ws);
        })
    }, []);

    const getRBACPermissions = async () => {
        const orgPropertyData = await getOrgsAndProperties(currentWorkspaceId);
        const rbacPermissionsPayload = getOrgPropertyRBACActions({...{currentWorkspaceId},...orgPropertyData});
        const { data: { allowed_operations = [] } }: any = await verifyRBACPermission(rbacPermissionsPayload);
        if (isPermissionAccess(allowed_operations, RBAC_ACTIONS.member.read)) {
            setIsPermissionToMember(true)
        }
    };
  
    const fetchCurrentWorkspaceById = async (workspaceId: string) => {
      await props.fetchWorkspaceById(workspaceId);
    }

    useEffect(() => {
      if (props.currentWorkspaceId && props.currentUser) {
        setIsPermissionToMember(false);
        if (checkUserPermissionWithOrgsOwnerShip() && currentOrgId) {
          setIsPermissionToMember(checkOrgOwnership(currentUser?.authorities, ['WRITE', 'READ'], currentOrgId));
        } else {
          getRBACPermissions();
        }
        fetchCurrentWorkspaceById(props.currentWorkspaceId);
      }
    }, [props.currentWorkspaceId, props.currentUser]);

    const workSpaceCallback = () => {
        setIsEditWorkSpace('')
        props.fetchWorkspaces();
    }

    const getNoAccessTooltip = () => {
        return <div>{t(`global.info.you_dont_have_access_to_this_page`)}</div>;
    };

    const getMenuList: any = () => {
        const extraMenu = props.workspaces?.length ? [{
            name: <Tooltip
                overlayClassName='tooltip'
                {...(isPermissionToMember ? { visible: false } : {})}
                placement='right'
                title={() => (isPermissionToMember ? null : getNoAccessTooltip())}>
                {t('global.title.members')}
            </Tooltip>,
            key: '3',
            disabled: !isPermissionToMember,
            icon: <img className='sidebar-menu-icons' style={{opacity:isPermissionToMember? 1:0.3}} src={MemberIcon}></img>,
            onClick: (e: any) => {
                setSelectedMenu(e.key)
                history.push({ pathname: RoutePaths.MEMBERS().toString(), ...getSelectedWorkspaceAndOrgId(), state: { sideKey: e.key } });
                handleCancel();
            },
        },
        {
            name: t('global.title.plans'),
            key: '4',
            icon: <img className='sidebar-menu-icons' src={PlanIcon}></img>,
            onClick: (e: any) => {
                setSelectedMenu(e.key)
                history.push({ pathname: RoutePaths.PLANS().toString(), ...getSelectedWorkspaceAndOrgId(), state: { sideKey: e.key } });
               handleCancel();
            },
        }] : [];
        return [{
            name: t('global.title.overview'),
            onClick: (e: any) => {
                setSelectedMenu(e.key)
                history.push({ pathname: RoutePaths.WORKSPACES(), ...getSelectedWorkspaceAndOrgId(), state: { sideKey: e.key } });
                handleCancel();
            },
            key: '1',
            icon: <img className='sidebar-menu-icons' src={HomeIcon}></img>,
        },
        {
            name: t('global.title.edit_profile'),
            key: '2',
            icon: <img className='sidebar-menu-icons' src={PersonIcon}></img>,
            onClick: (e: any) => {
                setSelectedMenu(e.key)
                history.push({ pathname: RoutePaths.PROFILE().toString(), ...getSelectedWorkspaceAndOrgId(), state: { sideKey: e.key } });
                handleCancel();
            },
        }, ...extraMenu]
    }

    const processSidebarMenu = () => {
        if (location.pathname.includes(RoutePaths.MEMBERS())) {
            setSelectedMenu('3')
        } else if (location.pathname.includes(RoutePaths.PLANS())) {
            setSelectedMenu('4')
        } else if (location.pathname.includes(RoutePaths.OVERVIEW())) {
            setSelectedMenu('1')
        } else if (location.pathname.includes(RoutePaths.PROFILE())) {
            setSelectedMenu('2')
        }
    };

    useEffect(() => {
        processSidebarMenu();
    }, [location.pathname, localStorage.getItem('i18nextLng'), props.rbacPermissions]);

  return (
    <>
      <div className='workspace-sidebar-container'>
        {
          props.workspaces.length > 0 &&
          <WorkspaceSelection
            {...props}
          />
        }
        <Sidebar
          className='sidebar-container'
          theme='light'
          selectedKeys={selectedMenu}
          menuItems={getMenuList()}
          collapsedMenu={false}
        />
        <LearnMore currentWorkspaceName={props.currentWorkspace.name} />
      </div>  
        {
          isEditWorkSpace ?
          <WorkspaceCreateEditModal
            deleteModalVisible={deleteModalVisible}
            workspaceData={isEditWorkSpace}
            setIsEditWorkSpace={setIsEditWorkSpace}
            setDeleteModalVisible={setDeleteModalVisible}
            deleteWorkspace={deleteWorkspaceAction}
            editWorkspace={editWorkspaceAction}
            createWorkspace={createWorkspaceAction}
            callBack={workSpaceCallback}
          /> : null
        }
    </>
  );
}

const mapStateToProps = (state: any) => ({
  currentUser: getCurrentUser(state),
  workspaces: get(state, 'workspaces.workspaces', []),
  workspaceLoading: get(state, 'workspaces.loading', true),
  currentWorkspaceId: getDefaultWorkspace(state),
  currentWorkspace: get(state, 'workspace.workspace', {}),
  orgs: get(state, 'orgsState.orgs', []),
  currentOrg: getCurrentOrg(state),
});

const mapDispatchToProps = (dispatch: any) => ({
  setCurrentWorkspaceId: (licensingAccountId: UUID) => dispatch(setCurrentWorkspace(licensingAccountId)),
  deleteWorkspace: (accountId: string) => dispatch(deleteWorkspace(accountId)),
  setCurrentOrg: (orgId: UUID) => dispatch(setCurrentOrg(orgId)),
  editWorkspace: (workspace: WorkspaceEdit) => dispatch(editWorkspace(workspace)),
  createWorkspace: (newWorkspace: any) => dispatch(createNewWorkspace(newWorkspace)),
  fetchWorkspaces: () => dispatch(getStoreAppsPerWorkspace()),
  fetchWorkspaceById: (workspaceId: string) => dispatch(getWorkspaceById(workspaceId))
});

export const WorkspaceSidebar = withRouter(
    connect(mapStateToProps, mapDispatchToProps)(WsSidebar),
);
